import ValueObject from './ValueObject';

export default class MetroCode extends ValueObject {
  equals(other) {
    if (!(other instanceof MetroCode)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new MetroCode(json);
  }
}
